import React from 'react'

const TabSaveIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8398 15.9609V14.2943C11.8398 12.7229 11.8398 11.9373 11.3517 11.4491C10.8635 10.9609 10.0778 10.9609 8.50651 10.9609H7.67318C6.10183 10.9609 5.31615 10.9609 4.828 11.4491C4.33984 11.9373 4.33984 12.7229 4.33984 14.2943V15.9609" stroke="#222222" strokeWidth="1.5" />
            <path d="M4.33984 5.21875H8.50651" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M1 6C1 3.64297 1 2.46447 1.73223 1.73223C2.46447 1 3.64297 1 6 1H11.9763C12.3169 1 12.4872 1 12.6404 1.06343C12.7935 1.12687 12.914 1.2473 13.1548 1.48816L15.5118 3.84517C15.7527 4.08603 15.8732 4.20647 15.9366 4.35961C16 4.51275 16 4.68307 16 5.02369V11C16 13.357 16 14.5355 15.2677 15.2677C14.5355 16 13.357 16 11 16H6C3.64297 16 2.46447 16 1.73223 15.2677C1 14.5355 1 13.357 1 11V6Z" stroke="#222222" strokeWidth="1.5" />
        </svg>

    )
}

export default TabSaveIcon